angular.module('CarsSaraBo').controller('RangeDefinitionController', ['$scope', '$routeParams','RangeDefinitionService','RangeDefinitionListService', 'GAService',
                                             function($scope, $routeParams,rangeDefinitionService, rangeDefinitionListService, gaService) {
	$scope.rangeDefinitions = {};
	$scope.initialize = function() {
		$scope.maxAdditionalRanges =4;
		$scope.validations = {lockSaveButton:false};
		$scope.editable = false;
		$scope.loadCompany();
		$scope.min=($scope.rangeDefinitions[0]==undefined)?(1):(parseInt($scope.rangeDefinitions[0].startRange)-1);
		$scope.min2=($scope.rangeDefinitions[1]==undefined)?(30):(parseInt($scope.rangeDefinitions[1].startRange));
		$scope.max=30;
		$scope.list1 = [2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30];
		$scope.list2 = [];
		$scope.qadataCounter = 0;
		$scope.editableRangeDefinition = $scope.loggedUserAllowed('PERM_RANGE_DAYS_CREATE') || $scope.loggedUserAllowed('PERM_RANGE_DAYS_EDIT') ||  $scope.loggedUserAllowed('PERM_RANGE_DAYS_DELETE');
	}
	
	$scope.loadCompany = function(){
		rangeDefinitionService.get({companyOid: $routeParams.oid }, function(response) {
			$scope.rangeDefinitions = response.sort(function compare(a,b) {
				  if (a.startRange < b.startRange)
					    return -1;
					  if (a.startRange > b.startRange)
					    return 1;
					  return 0;
					});
			$scope.rangeDefinitions;
		});
	}
	
	$scope.updateValidation = function(field){
		if($scope.errorField!=undefined && $scope.errorField[field]){
			$scope.errorField[field]=null;
		}
	}
	
	$scope.save = function(){
		$scope.validations.lockSaveButton = true;
		if($scope.rangeDefinitionForm.$valid){
            newRanges = _.filter($scope.rangeDefinitions, function(range) {return range.oid === null;});
            editedRanges = _.filter($scope.rangeDefinitions, function(range) {return range.oid > 0;});
            rangeDefinitionListService.post({"companyOid":$routeParams.oid},$scope.rangeDefinitions)
				.$promise
				.then(function(response) {
				    $scope.trackEventsGA(newRanges, editedRanges);
					$scope.loadCompany();
					$scope.notifyInfoByCode('range_definition.confirmationMessage.SUCCESS');
				}, function(response) {
				    if(response.data.length > 0 ) {
				        $scope.errorField={};
			            for(index in response.data){
			                $scope.errorField[response.data[index]]="input-error";
			            }
				    }
				}).finally(function(){
				$scope.validations.lockSaveButton = false;
			});
		}else{
			$scope.errorField={};
			for(i in $scope.rangeDefinitionForm.$error.required){
				$scope.errorField[$scope.rangeDefinitionForm.$error.required[i].$name]="input-error";
			}
            for(i in $scope.rangeDefinitionForm.$error.pattern){
                $scope.errorField[$scope.rangeDefinitionForm.$error.pattern[i].$name]="input-error";
                $scope.notifyErrorByCode('ERROR.name.valid');
            }
		}
		$scope.notifyFormErrors($scope.rangeDefinitionForm.$error);
		$scope.validations.lockSaveButton = false;
	}

	$scope.trackEventsGA = function(newRanges, editedRanges) {
	    try{
            if(newRanges != null && newRanges.length > 0) {
                var labelNew = _.reduce(newRanges, function(label, range){ return label + "(" + range.name + ", " + range.startRange + ");"; }, "new:");
                gaService.notify("Autos_rangos_de_dias", "nuevo_rango", [labelNew]);
            }
            if(editedRanges != null && editedRanges.length > 0) {
                var labelEdited = _.reduce(editedRanges, function(label, range){ return label + "(" + range.name + ", " + range.startRange + ");"; }, "edited:");
                gaService.notify("Autos_rangos_de_dias", "editar_rango", [labelEdited]);
            }
	    } catch(error) {
	    }
	}
	
	$scope.create = function(){
		$scope.qadataCounter++;
		if($scope.rangeDefinitions.length>$scope.maxAdditionalRanges){return false;}
		$scope.rangeDefinitions.push({"oid":null,"version":0,"name":"","startRange":($scope.getMin())})
	}
	
	$scope.getMin = function(){
		return (!$scope.rangeDefinitions[0])?(2):(parseInt($scope.rangeDefinitions[$scope.rangeDefinitions.length -1].startRange)+1);
	}
	
	$scope.cancel = function(){
		$scope.showModal("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION", function() {
			$scope.initialize();
		});
		
	}
	
	$scope.getTo = function(index){
		return (!$scope.rangeDefinitions[index+1])?($scope.max):(parseInt($scope.rangeDefinitions[index+1].startRange));
	}
	
	$scope.getNumber = function(index) {
		var indice = parseInt($scope.rangeDefinitions[index-1].startRange) + 1;
		// el rango del medio solo puede seleccionar hasta el dia X en función de la cantidad de rangos y el indice para mantener consistente el siguente rango.
		var to = (index === $scope.maxAdditionalRanges || !$scope.rangeDefinitions[index+1]) ? $scope.max -1 : $scope.max - ($scope.rangeDefinitions.length -index);

		var array = [];

		if($scope.rangeDefinitions[index+1] && $scope.rangeDefinitions[index] &&
				parseInt($scope.rangeDefinitions[index].startRange)>=parseInt($scope.rangeDefinitions[index+1].startRange)){
			
			$scope.editable=true;
			var startRange2 = parseInt($scope.rangeDefinitions[index].startRange) + 1;
			$scope.rangeDefinitions[index+1].startRange = startRange2.toString();
			for(var i=indice;i<=$scope.max;i++){
				array.push(i);
			}
		}else{
			for(var i = indice; i <= to; i++){
				array.push(i);
			}
		}
	    return array;
	}
	
	$scope.remove = function(id, index){
		$scope.showModal("REMOVE_ALERT_TITLE", "REMOVE_ALERT_DESCRIPTION", function() {
			if(id != null){
				var toBeRemoved = _.find($scope.rangeDefinitions, {oid: id});
				var label = "(" + toBeRemoved.name + ", " + toBeRemoved.startRange + ")";
				rangeDefinitionService.remove({companyOid: $routeParams.oid, oid: id })
					.$promise
					.then(function(response) {
	            		gaService.notify("Autos_rangos_de_dias", "eliminar_rango", [label]);
						$scope.loadCompany();
						$scope.notifyInfoByCode('common.confirmationMessage.SUCCESS_DELETE');
					});
			}else{
				$scope.rangeDefinitions.splice(index, 1);
			}
		});
	};

	$scope.initialize();
}]); 


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/general_conditions_controllers/range_definition_controller.js
// module id = 916
// module chunks = 3